import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import UserProfile from '../Components/casp/common/userProfile';
import { ucFirst } from '../helpers/string_helper';

const ContentInfo = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event.stopPropagation()
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <ErrorOutlineOutlinedIcon
                style={{ cursor: "pointer", height:'18px' }}
                onClick={handleClick}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div className="p-3">
                    <div className="">
                        <h6>{props?.content?.user?.name}</h6>
                        <div className='d-flex'>
                            <UserProfile user={props.content?.user} avatarClassName='me-2 ml-2' profileClassName='me-2 ml-2' profileStyle={{ height: '28px', width: '28px', fontSize: '12px' }} />
                            <div className="concern_person" style={{ fontSize: '12px' }}>
                                <small>{ucFirst(props.content?.user?.projectUsers[0]?.role?.name)}</small>
                                <p className='mb-0'>{props.content?.user?.uniqueUserId}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Popover>
        </>

    )
}

export default ContentInfo;